import { getAdminUser, hasAnyPermission } from "../api/adminClient";

/**
 * Workspace actions the platform copilot may suggest. Values are stable keys for rules/tools.
 * Each action lists permission strings; any match grants the action.
 */
export const ASSISTANT_ACTION_DEFS = [
  {
    key: "invite_participants",
    label: "Create and send participant invites",
    permissions: ["invites:write", "invites:send"],
  },
  {
    key: "resend_invitations",
    label: "Resend invitation emails",
    permissions: ["invites:send"],
  },
  {
    key: "view_invite_pipeline",
    label: "View invite list and participant status",
    permissions: ["invites:read"],
  },
  {
    key: "configure_reminder_cadence",
    label: "Configure automated reminder schedule",
    permissions: ["invites:manage"],
  },
  {
    key: "open_company_reports",
    label: "Open or generate company assessment reports",
    permissions: ["reports:read", "companies:read"],
  },
  {
    key: "export_report_data",
    label: "Export survey responses",
    permissions: ["reports:export"],
  },
  {
    key: "view_portfolio_analytics",
    label: "View portfolio operations analytics",
    permissions: ["analytics:read"],
  },
  {
    key: "view_portfolio_insights",
    label: "View portfolio performance and scores",
    permissions: ["insights:read"],
  },
  {
    key: "manage_report_profiles",
    label: "Edit PDF report profile templates",
    permissions: ["report_profiles:manage", "report_profiles:read"],
  },
  {
    key: "manage_email_templates",
    label: "Edit Mail Manager templates and routing",
    permissions: ["templates:manage"],
  },
  {
    key: "manage_assessment",
    label: "Edit survey questions and LITE selection",
    permissions: ["assessment_form:manage", "survey_templates:manage"],
  },
  {
    key: "manage_companies",
    label: "Create or edit company profiles",
    permissions: ["companies:write", "companies:manage"],
  },
  {
    key: "use_ai_copilot",
    label: "Use NEXUS admin copilot",
    permissions: ["ai_copilot:use"],
  },
];

function callerMayUseAction(permissions) {
  const user = getAdminUser();
  if (!user) return false;
  if (user.is_platform_admin) return true;
  const granted = user.permissions;
  if (!Array.isArray(granted) || granted.length === 0) {
    // Pre-RBAC / classic sessions: allow standard workspace actions when signed in.
    return true;
  }
  return hasAnyPermission(permissions);
}

/** Allowed action keys + human labels for the signed-in admin. */
export function buildAssistantAllowedActions() {
  const allowed = [];
  const labels = {};
  for (const def of ASSISTANT_ACTION_DEFS) {
    if (callerMayUseAction(def.permissions)) {
      allowed.push(def.key);
      labels[def.key] = def.label;
    }
  }
  return { allowedActions: allowed, actionLabels: labels };
}
